import { createSelector } from '@reduxjs/toolkit';
import {
  selectNormalProjectsArray,
  selectProjectsArray,
  selectSelectedProject,
} from './projectsSelectors';
import { selectSelectedRecord } from 'store/records/selectors/records.selectors';
import returnProjectIdAndItsChildProjectIds from 'scenes/WorkDemo/utils/returnProjectIdAndItsChildProjectIds';
import { selectWorkCalendarProjectsArray } from 'scenes/WorkDemo/store/selectors/workSelectorsDemo';
import { selectUserAdminBusinessIds } from 'scenes/Permissions/store/selectors/base-project-permissions.selectors';
import { sortBy, uniqBy } from 'lodash-es';

export const selectEditDialogProjectOptions = createSelector(
  selectSelectedProject,
  selectWorkCalendarProjectsArray,
  selectNormalProjectsArray,
  selectSelectedRecord,
  selectUserAdminBusinessIds,
  (
    selectedProject,
    workCalendarProjects,
    projects,
    selectedRecord,
    userAdminBusinessIds
  ) => {
    let options = [];

    if (
      selectedProject.businessTypeEnum === 'EMPLOYER' &&
      userAdminBusinessIds.length > 0
    ) {
      options = [...workCalendarProjects, ...projects];

    } else {
      const projectsToSearch = returnProjectIdAndItsChildProjectIds(
        [selectedProject.id],
        projects
      );
      // records project is not always selected projects child. for example if record is in subcontractor project.
      // adding records selected project to options.
      options = projects.filter(
        (project) =>
          projectsToSearch.includes(project.id) ||
          project.id === selectedRecord.project
      );
    }

    const uniqueOptions = uniqBy(options, 'id');
    console.log('uniqueOptions:', uniqueOptions)

    return sortBy(uniqueOptions, [(project) => (project.name || '').toLowerCase()]);
  }
);

export const selectCreateRecordProjectOptions = createSelector(
  selectSelectedProject,
  selectProjectsArray,
  (currentProject, projects) => {
    let projectsToSearch = returnProjectIdAndItsChildProjectIds(
      [currentProject.id],
      projects
    );

    let options = projects.filter((project) =>
      projectsToSearch.includes(project.id)
    );

    const uniqueOptions = uniqBy(options, 'id');

    return sortBy(uniqueOptions, [(project) => (project.name || '').toLowerCase()]);
  }
);
